import React from 'react';
import ReportingMarketingShowTrackerPage from '../components/ReportingMarketingShowTrackerPage';

const ReportingMarketingShowTrackerApp = (props) => (
  <ReportingMarketingShowTrackerPage {...props} />
);

export default ReportingMarketingShowTrackerApp;
